/**
 * Contribution Middleware
 *
 * Blocks access for individual members whith an expired membership
 * (unpaid contribution after the March 31st grace period).
 * Redirects to the access-denied page with a contribution context.
 */
export default defineNuxtRouteMiddleware(async () => {
  const localePath = useLocalePath()

  const authStore = useAuthStore()
  const authDataStore = useAuthDataStore()

  if (authStore.token && !authDataStore.userData) {
    await authStore.me()
  }

  // Only applies to individual members
  if (!authDataStore.isIndividuel) return

  const { hasExpiredMembership } = useContributionStatus()

  if (hasExpiredMembership.value) {
    return navigateTo({
      path: localePath({ name: 'auth-access-denied' })
    })
  }
})
